import { useState } from "react";

export default function SubscribeBox() {
  const [value, setValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null); // new | returning | error
  const [message, setMessage] = useState("");

  const handleSubmit = async () => {
    if (!value.trim()) {
      setStatus("error");
      setMessage("فضلاً أدخل البريد الإلكتروني أو رقم الجوال");
      return;
    }

    setLoading(true);
    setStatus(null);
    setMessage("");

    try {
      const res = await fetch("/api/subscribe.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          value,
          source: "subscribe_box"
        }),
      });

      const data = await res.json();

      if (!data.ok) {
        throw new Error("Server error");
      }

      if (data.status === "new_lead") {
        setStatus("new");
        setMessage("تم استلام طلبك بنجاح، سنقوم بالتواصل معك قريبًا");
      } else if (data.status === "returning_lead") {
        setStatus("returning");
        setMessage("أهلًا بك مجددًا، تم تحديث طلبك وسنتواصل معك قريبًا");
      }

      setValue("");
    } catch (e) {
      setStatus("error");
      setMessage("حدث خطأ أثناء الإرسال، حاول لاحقًا");
    }

    setLoading(false);
  };

  return (
    <div className="mt-12 px-4">
      <div className="max-w-xl mx-auto flex flex-col gap-3">
        <div className="flex flex-col sm:flex-row gap-3">
          <input
            type="text"
            placeholder="اكتب بريدك الإلكتروني أو رقم جوالك"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            disabled={loading}
            className="flex-1 px-4 py-3 rounded-lg border"
          />
          <button
            onClick={handleSubmit}
            disabled={loading}
            className="px-6 py-3 bg-[#4A9FD8] text-white rounded-lg"
          >
            {loading ? "جاري الإرسال..." : "تواصل معنا"}
          </button>
        </div>

        {status && (
          <p
            className={`text-sm text-center ${
              status === "error" ? "text-red-600" : "text-green-600"
            }`}
          >
            {message}
          </p>
        )}
      </div>
    </div>
  );
}
